import * as React from 'react';

/**
 * Returns whether the given media query currently matches, updating in both
 * directions as the viewport crosses the breakpoint.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = React.useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);

  React.useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};
